<!-- Este es un componente auxiliar que genera los selectores de altura, -->
<!-- desarrollo y desnivel. Recibe el parámetro nombre y emite el -->
<!--  objeto select que contiene el valor limite, si es más y si está selecc. -->
<template>
  <div class="filtroGEN" @change="doEmit">
    <div class="L1">
      <input type="checkbox" name="check"
        class="checkMark"
        v-model.trim="marcado"
        :disabled="imposible" >
      <p>{{ nombre }}</p>
    </div>
    <div class="linea">
      <button @click="less" class="button" :disabled="imposible2">
        <span class="icon-icoMenosSolo ico" :class="pulsadoMenos"></span>
      </button>
      <input type="number" v-model="valorFiltro" class="campo1" min="0">
      <button @click="more"
        class="button" :class="pulsadoMas">
        <span class="icon-icoMasSolo ico" :class="pulsadoMas"></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    nombre: String
  },
  emits: ['select'],

  data () {
    return {
      mayorQue: true,
      valorFiltro: 0,
      marcado: false,
      pulsadoMas: 'BtnFilPul',
      pulsadoMenos: '',
      status: {}
    }
  },
  methods: {
    more () {
      this.pulsadoMas = 'BtnFilPul'
      this.pulsadoMenos = ''
      this.mayorQue = true
      this.doEmit()
    },
    less () {
      this.pulsadoMas = ''
      this.pulsadoMenos = 'BtnFilPul'
      this.mayorQue = false
      this.doEmit()
    },
    doEmit () {
      // this.status.nombre = this.nombre
      this.status.check = this.marcado
      this.status.masQue = this.mayorQue
      this.status.valorFil = this.valorFiltro
      this.$emit('select', this.status)
    }
  },
  computed: {
    imposible () {
      if (!this.mayorQue && this.valorFiltro === 0) {
        return true
      } else {
        return false
      }
    },
    imposible2 () {
      if (this.marcado && this.valorFiltro === 0) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.L1{
  display: flex;
  flex-direction: column;
}
.L1 p{
  margin-bottom: 1px;
  color: black;  font-weight: 600;
  font-size: 1.2vw;
  align-self: center;
  line-height: 0.5;
  margin-bottom: 3px;
  transform: translateY(-3px);
}
.campo1{
  background-color: rgb(238, 238, 238);
  border: solid 0.5px rgb(199, 191, 188);
  border-radius: 3px;
  width: 70%;
  font-size: 15px;
  padding-left: 6px;
  height: 20px;
  align-self: center;
}
.campo1:focus{
  outline-color: rgb(157, 216, 255);
}
.filtroGEN{
  width: 170px;
  height: 55px;
  border: solid 0.5px gray;
  border-radius: 3px;
  margin-top: 10px;
  background-color: rgba(228, 228, 228, 0.8);
}
.checkMark{
  scale: 1.4;
  align-self: flex-end;
  position: relative;
  right: -1px;
  top: -1px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  border: 1px solid #BEBEBE;
  background-color: #E9E9E9;
  color: white;
}
.checkMark:checked {
  background-color: #FAAD1E;
  border: solid 3px#A5A4A4;
  color: white;
}
.linea{
  display: flex;
  justify-content: space-around;
}
.button{
  display: flex;
  width: 30%;
  /*height: 70%;*/
  background-color: transparent;
  border-color: transparent;
  font-weight:400 ;
  font-size: 14px;
}
.button:disabled + eti {
  color: darkgrey;
}
button:hover:enabled{
  background-color: rgb(220, 228, 227);
  cursor: pointer;
  /* transform: scale(1.08); */
}
.ico:hover{
  transform: scale(1.08);
}
.icon-icoMasSolo{
  color: rgb(199, 199, 199);
  font-size: 1.1em;
  padding-left: 5px;
  padding-right: 5px;
}
.icon-icoMenosSolo{
  color: rgb(199, 199, 199);
  font-size: 1.2em;
  padding-left: 4px;
  padding-right: 4px;
}
.BtnFilPul{
  color: rgb(253, 164, 0);
}

@media screen and (max-width: 600px){
  .Blk-Btn {
    width: 95vw;
    display: flex;
    flex-direction: row;
    justify-content:space-evenly;
    margin: 4vw 0 2vw 0;
    column-gap:2px;
  }

  .L1 p{
    font-size: calc(9px + 0.8vw);
    height: 95%;
    transform: translateY(-6px);
  }
  .linea{
    transform: translateY(-4px);
  }
  .button {
    /* border: solid white 0.5px; */
    border-radius: 3px;
    font-size: 12px;
    width: 20%;
    aspect-ratio: 1;
    margin: 0 1px;
  }
  .icon-icoMasSolo{
    font-size: 1em;
    padding-left: 1px;
    padding-right: 4px;
    padding-top: 1.5px;
  }
  .icon-icoMenosSolo{
    font-size: 1em;
    padding-left: 1px;
    padding-right: 3px;
    padding-top: 1.5px;
  }
  .filtroGEN{
    width: 30vw;
    height: 42px;
    border: solid 0.5px gray;
    border-radius: 3px;
    margin-top: 5px;
    background-color: rgba(228, 228, 228, 0.8);
  }
  .checkMark{
  scale: 1.2;
  align-self: flex-end;
  position: relative;
  right: -1.3px;
  top: -1.3px;
}
}
</style>
